import { JSX } from "react";
import { Products } from "./components/Products";
import { ExplanationModal } from "./components/ExplanationModal";
import { Filters } from "./components/Filters";
import { Header } from "./components/Header";
import { CartToastContainer } from "../../common/components/cartToast/CartToastContainer";

export const RefurbishedPageContainer = (): JSX.Element => {
    return (
        <div className={"p-refurbished"}>
            <Header />
            <Filters />
            <Products />
            <ExplanationModal />
            <CartToastContainer />
        </div>
    );
};
